import styled from 'styled-components'

export const FromMain = styled.form`
  display: flex;
  animation: identifier 2s;
  flex-direction: column;
  align-items: center;
  width: 355px;
  gap: 20px;
  background: linear-gradient(to bottom, #002cb077, #001843);
  box-shadow: 5px -5px 30px 2px rgba(0, 0, 0, 0.09);
  border-radius: 25px;
  color: #ffffff;
  padding: 20px 20px 40px 20px;
  font-family: 'Montserrat', sans-serif;

  .back-arrow {
    width: 100%;
    display: flex;
    align-items: center;
    gap: 10px;

    img {
      width: 30px;
    }
  }

  button {
    background: transparent;
    border: none;
    width: 280px;
    height: 40px;
    color: #ffffff;
    justify-content: center;
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    border-radius: 20px;

    .btn-text {
      position: absolute;
      font-size: 20px;
      font-weight: 700;
      font-family: 'Inter', sans-serif;
    }
  }

  input {
    width: 280px;
    height: 45px;
    border-radius: 20px;
    border: none;
    padding: 0 20px;
    font-family: 'Montserrat', sans-serif;

    &::placeholder {
      color: #0000008e;
    }
  }

  a {
    color: #ffffff;
  }

  .logo-footer {
    position: absolute;
    right: 20px;
    bottom: 20px;
    animation: logoOn 400ms;
    display: flex;
    align-items: center;
    gap: 5px;

    img {
      width: 60px;
    }

    span {
      color: #ffffff;
      font-size: 12px;
      font-family: 'Montserrat', sans-serif;
      font-weight: 600;
    }
  }
`
